import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=06c2d488&"
import script from "./file-uploader.vue?vue&type=script&lang=ts&"
export * from "./file-uploader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports